import { JsonObject, JsonProperty } from 'json2typescript';

//** Model stanice použitý v mapě * /
@JsonObject("MapStation")
export class MapStation {
  @JsonProperty('id', String)
  id: string = ""
  @JsonProperty('name', String)
  name: string = ""
  @JsonProperty('zone', Number, true)
  zone: number | undefined = undefined
  @JsonProperty('sourceType', String)
  sourceType: string = ""
  @JsonProperty('lat', Number)
  lat: number = 0;
  @JsonProperty('lon', Number)
  lon: number = 0;
}
